import { render, staticRenderFns } from "./edit-lab-modal.vue?vue&type=template&id=b8c077b6"
import script from "./edit-lab-modal.vue?vue&type=script&lang=js"
export * from "./edit-lab-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports